import { GlobalParams } from "./types/globalParams";

export const getGlobalParams = (): GlobalParams => window.srmCore.globalParams;
